import React from "react";
import abtbg2 from "../../Assets/images/features-bg.webp";
import featureicon1 from "../../Assets/images/featureicon1.gif";
import featureicon2 from "../../Assets/images/featureicon2.gif";
import featureicon3 from "../../Assets/images/featureicon3.gif";
import wallet from "../../Assets/images/exbit-features.mp4";

const Features = () => {
  return (
    <>
      <section className=" py-6 md:py-12  relative overflow-hidden">
        <div className="mx-auto max-w-7xl container  px-4 sm:px-6 lg:px-8  relative ">
          <div className="mb-14 text-center flex flex-col">
            <span className="py-2 px-4 span-bx rounded-full text-md font-medium text-[#ffe400ba] text-center w-24 mx-auto">
              Wallet
            </span>
            <h2 className="text-4xl text-center font-bold  bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text leading-[3rem] mb-6 max-w-max lg:max-w-2xl lg:mx-auto">
              The Exbit Wallet: Your Gateway to Digital Assets
            </h2>
            <p className="text-base font-normal text-gray-400 lg:max-w-2xl lg:mx-auto mb-8">
              The Exbit Wallet combines security, versatility, and simplicity,
              making it an essential tool for managing your cryptocurrencies:
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-lg mx-auto md:max-w-2xl lg:max-w-full  ">
            <div className="relative w-full h-auto md:col-span-2">
              <div className="feature rounded-2xl flex  justify-between flex-row flex-wrap">
                <div className="p-5  xl:p-8 w-full md:w-1/2 ">
                  <div className="block">
                    <img
                      src={featureicon1}
                      alt="Icon"
                      className="w-[45px] auto"
                    />
                  </div>
                  <h3 className="text-lg font-bold xl:text-xl feature-text py-5 w-full xl:w-64">
                    Exbit Wallet offers multi-chain support and NFT
                    compatibility.:
                  </h3>
                  <p className="text-sm font-normal text-gray-300 w-full mb-8 xl:w-64">
                    Seamlessly access and manage assets across multiple
                    blockchains, and securely store or beautifully showcase your
                    NFTs effortlessly.
                  </p>
                </div>
                <div className="relative hidden h-auto md:w-1/2 md:block">
                  <video
                    src={wallet}
                    className="h-full ml-auto object-cover mix-blend-exclusion"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
            <div className="relative w-full h-auto">
              <div className="feature rounded-2xl p-5  xl:p-6 h-full">
                <div className="block">
                  <img
                    src={featureicon2}
                    alt="Icon"
                    className="w-[45px] auto"
                  />
                </div>
                <h3 className="py-5 feature-text text-lg font-bold xl:text-xl">
                  Exbit Wallet offers Integrated Swap & Security
                </h3>
                <p className="text-sm font-normal text-white mb-8">
                  Swap tokens directly within the wallet, backed by advanced
                  encryption to ensure your funds and data are always protected.
                </p>
              </div>
            </div>
            <div className="relative w-full h-auto">
              <div className="feature rounded-2xl p-5 xl:p-8 h-full">
                <div className="block">
                  <img
                    src={featureicon3}
                    alt="Icon"
                    className="w-[45px] auto"
                  />
                </div>
                <h3 className="py-5 feature-text text-lg font-bold xl:text-xl">
                  Exbit Wallet offers an innovative user-centric design.
                </h3>
                <p className="text-sm font-normal text-white mb-8">
                  Enjoy a sleek, intuitive interface designed for effortless
                  navigation.
                </p>
              </div>
            </div>
          </div>
          <div className="feature-box max-w-24  ">
            <img
              src={abtbg2}
              alt="collection-pattern"
              className=" pattern-2 -z-10 "
            />
          </div>
        </div>
        <div className="section_about-bg-gradient animate-pulse " />
      </section>
    </>
  );
};

export default Features;
